"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Audiences",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Customers",
    transform: "translate(-576.000000, -85.000000)",
    fill: props.fill
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-9",
    transform: "translate(566.000000, 79.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.9903766,16 L14.9917602,19.979126 L21.3137085,14.3431458 L14.9876006,8.01703815 L14.9889856,12 L10,12 L10,16 L14.9903766,16 L14.9903766,16 Z M24,8 L24,20 L19,20 L19,22 L25,22 L26,22 L26,7 L26,6 L19,6 L19,8 L24,8 L24,8 Z",
    id: "Archive",
    transform: "translate(18.000000, 14.000000) rotate(-270.000000) translate(-18.000000, -14.000000) "
  })))));
};

exports["default"] = _default;